import { toApiUrl } from '../config/api';
import { fetchAuthedApiResponse, fetchPublicApiResponse } from './http';

export function postLoginResponse(formData: FormData): Promise<Response> {
  return fetchPublicApiResponse(toApiUrl('/login'), {
    method: 'POST',
    body: formData,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
}

export function fetchRegistrationPrefillResponse(token: string): Promise<Response> {
  const params = new URLSearchParams({ token });
  return fetchPublicApiResponse(toApiUrl(`/api/public/sales-registration-link/prefill?${params.toString()}`), {
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  });
}

export function postRegisterResponse(formData: FormData): Promise<Response> {
  return fetchPublicApiResponse(toApiUrl('/register'), {
    method: 'POST',
    body: formData,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
}

export function fetchGoogleFollowupPrefillResponse(): Promise<Response> {
  return fetchPublicApiResponse('/auth/google-followup', {
    headers: { Accept: 'application/json' },
    credentials: 'include',
  });
}

export function postGoogleFollowupResponse(payload: URLSearchParams): Promise<Response> {
  return fetchPublicApiResponse('/auth/google-followup', {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: payload,
  });
}

export function fetchEmployeeGoogleFollowupPrefillResponse(): Promise<Response> {
  return fetchPublicApiResponse('/employee/auth/google-followup', {
    headers: { Accept: 'application/json' },
  });
}

export function postEmployeeGoogleFollowupResponse(payload: URLSearchParams): Promise<Response> {
  return fetchPublicApiResponse('/employee/auth/google-followup', {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: payload,
  });
}

export function postEmployeeRegisterResponse(formData: FormData, csrfToken?: string): Promise<Response> {
  const headers: HeadersInit | undefined = csrfToken ? { 'X-CSRF-Token': csrfToken } : undefined;
  return fetchPublicApiResponse('/employee/api/auth/register', {
    method: 'POST',
    body: formData,
    credentials: 'include',
    headers,
  });
}

export function fetchSetPasswordValidationResponse(token: string): Promise<Response> {
  return fetchPublicApiResponse(`/api/auth/set-password/validate?token=${encodeURIComponent(token)}`, {
    method: 'GET',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
}

export function fetchSessionMeResponse(init?: RequestInit): Promise<Response> {
  return fetchPublicApiResponse('/api/me', init);
}

export function fetchAuthMeAuthedResponse(
  options?: Parameters<typeof fetchAuthedApiResponse>[1],
): Promise<Response> {
  return fetchAuthedApiResponse('/api/me', options);
}

export function postLogoutResponse(endpoint = '/api/logout', init?: RequestInit): Promise<Response> {
  return fetchPublicApiResponse(endpoint, init);
}
